const cards = [
  {
    title: '某一线男星被曝隐婚生子，妻子竟是圈内知名经纪人',
    desc: '据知情人士透露，该男星与经纪人已秘密领证三年，孩子已满两岁。消息一出粉丝圈瞬间炸锅...',
    tag: '明星黑料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20silhouette%20of%20a%20person%20behind%20translucent%20curtain%20with%20warm%20spotlight%2C%20crimson%20and%20dark%20amber%20mood%2C%20mysterious%20atmosphere%2C%20paparazzi%20photography%20style%2C%20high%20contrast%2C%20editorial%20quality%2C%20dark%20elegant%20background&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '千万粉丝网红偷税漏税被查，补缴及罚款超三千万',
    desc: '税务部门已确认该网红通过多个壳公司转移收入，涉嫌严重偷逃税款，相关账号已被平台限流...',
    tag: '网红黑料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20stack%20of%20documents%20and%20ledgers%20in%20dramatic%20warm%20lighting%2C%20crimson%20accents%20on%20dark%20background%2C%20investigative%20mood%2C%20financial%20scandal%20theme%2C%20high%20contrast%20shadows%2C%20editorial%20photography%2C%20sophisticated%20atmosphere&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '综艺节目恶意剪辑被实锤，嘉宾原话与播出内容截然相反',
    desc: '一段未播出素材的泄露彻底揭开了某热门综艺的遮羞布，节目组为制造冲突不惜歪曲事实...',
    tag: '内幕曝光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20editing%20suite%20with%20multiple%20screens%20in%20warm%20dramatic%20light%2C%20red%20and%20amber%20color%20tones%2C%20mysterious%20atmosphere%2C%20behind%20the%20scenes%20aesthetic%2C%20cinematic%20mood%2C%20high%20contrast%2C%20dark%20sophisticated%20background&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '知名品牌代言人翻车，品牌方紧急解约索赔过亿',
    desc: '该明星因个人丑闻导致所代言品牌股价暴跌，多家品牌连夜发布解约声明，代言帝国一夜崩塌...',
    tag: '负面新闻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shattered%20billboard%20with%20dramatic%20lighting%20in%20warm%20crimson%20and%20amber%20tones%2C%20abstract%20commercial%20scene%2C%20high%20contrast%20shadows%2C%20editorial%20photography%20style%2C%20mysterious%20corporate%20mood%2C%20dark%20elegant%20background&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '女团成员内部霸凌录音流出，经纪公司紧急公关',
    desc: '长达四十分钟的录音记录了某女团成员被队友长期排挤、言语侮辱的惨痛经历，引发全网震怒...',
    tag: '黑料合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20group%20of%20figures%20with%20one%20isolated%20silhouette%2C%20dramatic%20warm%20lighting%20with%20crimson%20and%20amber%20tones%2C%20emotional%20mood%2C%20high%20contrast%2C%20editorial%20photography%2C%20dark%20theatrical%20atmosphere&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '短视频平台算法黑幕：谁在操控你的推荐流',
    desc: '内部员工匿名爆料，揭秘短视频平台如何通过算法操控舆论走向，特定内容被系统性限流...',
    tag: '内幕曝光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20algorithm%20visualization%20with%20warm%20red%20and%20gold%20pixels%20flowing%2C%20mysterious%20tech%20atmosphere%2C%20dramatic%20lighting%2C%20high%20contrast%2C%20dark%20sophisticated%20background%2C%20editorial%20style&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    title: '横店群演爆行业内幕：替身演员的悲惨生存现状',
    desc: '多位横店群演联合发声，揭露影视行业对底层演员的压榨，日薪不足百元却要承担高危动作戏...',
    tag: '负面新闻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Backstage%20film%20set%20with%20dramatic%20warm%20lighting%2C%20shadows%20of%20crew%20members%2C%20crimson%20and%20amber%20tones%2C%20mysterious%20behind%20the%20scenes%20atmosphere%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20dark%20mood&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门黑料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          近期最受关注的明星网红黑料大合集
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <a
              key={card.imageUrl}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group block bg-background-50 rounded-xl border border-secondary-200/60 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-secondary-200">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-[11px] font-medium rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-700 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
          {cards.length % 3 !== 0 && (
            <a
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="hidden lg:flex items-center justify-center bg-background-50 rounded-xl border border-dashed border-secondary-300 hover:border-primary-300 transition-all duration-200 cursor-pointer min-h-[200px]"
            >
              <span className="text-sm text-foreground-400">
                <i className="ri-add-line mr-1"></i>
                更多黑料
              </span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
}